import { memo } from "react"

import styled, { css } from "styled-components"

import { colors, spacing } from "@izettle/otto"

import { IconButton } from "../icon-button"

import { InputButtonProps } from "./types"

const mixinHover = ({ searchStyle }: InputButtonProps) =>
  searchStyle
    ? css`
        color: ${colors.icon.default};
        background: none;
      `
    : ""

const getIconColor = ({ color = "default" }: InputButtonProps) => {
  const isObject =
    typeof colors.icon[color] === "object" &&
    Object.prototype.hasOwnProperty.call(colors.icon[color], "small")
  return isObject ? colors.icon[color].small : colors.icon[color]
}

export const InputButtonGeneric = memo(styled(IconButton)<InputButtonProps>`
  color: ${getIconColor};
  font-size: 24px;
  display: flex;
  align-items: center;
  background: none;
  border: none;
  transition: color 0.1s cubic-bezier(0.25, 0.1, 0.25, 1);
  margin-right: ${spacing.small};
  outline: none;
  &:hover {
    ${mixinHover}
  }
`)

export const InputButtonGenericContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`
